// extracted by mini-css-extract-plugin
export default {"input_container":"salary-input_input_container__U+GQu","input_container_slider":"salary-input_input_container_slider__uXn9H","input":"salary-input_input__E6ojJ"};